import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ImageOptimisePreset, NO_AGENCY_IMAGE, NO_AGENT_IMAGE } from '@rma/generic/core/images';
import { isIndividual } from '@rma/generic/domain/helpers';
import { INDIVIDUAL, type ProfileType } from '@rma/generic/domain/types';
import { BrokenImageDirective } from '@rma/public/generic/ui/broken-image';
import { TrixelComponent } from '@rma/public/generic/ui/trixels';

@Component({
  selector: 'rma-profile-avatar',
  templateUrl: './profile-avatar.component.html',
  imports: [TrixelComponent, BrokenImageDirective, NgOptimizedImage],
  host: {
    class: 'block relative rounded-full overflow-hidden',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileAvatarComponent {
  public readonly avatar = input<string>();
  public readonly name = input<string>();
  public readonly profileType = input<ProfileType | null | undefined>(INDIVIDUAL);
  public readonly trixelUrl = input<string>();
  public readonly lazyLoad = input(true);
  public readonly backgroundColour = input<string>();
  public readonly size = input<'standard' | 'landscape' | 'large'>('standard');

  public readonly transformations = computed<ImageOptimisePreset>(() => {
    switch (this.size()) {
      case 'large':
        return 'AvatarLarge';
      case 'landscape':
        return 'AvatarLandscape';
      case 'standard':
      default:
        return 'AvatarStandard';
    }
  });

  public readonly placeholderImage = computed(() => (isIndividual(this.profileType()) ? NO_AGENT_IMAGE : NO_AGENCY_IMAGE));
}
